import { reduxActions } from '../constants';

const defaultFAQs = [];

export function faqList(state = defaultFAQs, action) {
    let list = [];

    switch(action.type) {
        case reduxActions.ADD_FAQ_ITEM:
            if (action.faq) {
                list = [
                    ...list,
                    ...state,
                    action.faq
                ];
            }

            if (action.faqs) {
                list = [
                    ...list,
                    ...state,
                    ...action.faqs
                ];
            }

            return list;

        case reduxActions.RESET_FAQ:
            return [];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/faq-reducer.js